module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body comitentes"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb76f1f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/comitentes/Main.vue
// module id = 706
// module chunks = 2